/* eslint-disable */

import axios from "axios";

const API_URL =
  process.env.REACT_APP_BASE_URL || "https://spectrumdecors.in/api/";
const Auth_token =
  process.env.REACT_APP_API_TOKEN || "ppvtech123";
// const API_URL = process.env.REACT_APP_API_URL || "api.ppvserver.com/";

// Helper function to convert JSON to URL encoded data
const JSON_to_URLEncoded = (element, key, list = []) => {
  if (typeof element === "object") {
    for (let idx in element) {
      JSON_to_URLEncoded(element[idx], key ? `${key}[${idx}]` : idx, list);
    }
  } else {
    list.push(`${key}=${encodeURIComponent(element)}`);
  }
  return list;
};

const ApiService = {
  // Upload file method
  uploadFile: async (files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append("userfile", file));
    return axios.post(`${API_URL}/users/upload_image`, formData);
  },

  // Post request with private authorization (JWT token)
  postPrivate: async (url, body) => {
    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${token}`,
    };
    const params = JSON_to_URLEncoded(body);
    try {
      const response = await axios.post(`${API_URL}${url}`, params.join("&"), {
        headers,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Post request with temporary authorization
  postTemp: async (url, body, tempToken) => {
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${tempToken}`,
    };
    const params = JSON_to_URLEncoded(body);
    try {
      const response = await axios.post(`${API_URL}${url}`, params.join("&"), {
        headers,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Upload image method (for images with extensions)
  uploadImage: async (url, blobData, ext) => {
    const formData = new FormData();
    formData.append("image", blobData, `image.${ext}`);
    try {
      const response = await axios.post(`${API_URL}${url}`, formData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Public POST request (no authentication required)
  postPublic: async (url, body) => {
    try {
      // console.log(`${API_URL}${url}`, body, "post link");

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const response = await axios.post(API_URL + url+Auth_token, body);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Public GET request (no authentication required)
  getPublic: async (url) => {
    const headers = { "Content-Type": "application/x-www-form-urlencoded" };
    try {
      // console.log("link", API_URL + url + Auth_token);
      const response = await axios.get(API_URL + url + `&authToken=${Auth_token}`, { headers });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Private GET request (authentication required)
  getPrivate: async (url) => {
    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${token}`,
    };
    try {
      const response = await axios.get(`${API_URL}${url}`, { headers });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // External GET request (no authentication required, external API)
  externalGet: async (url) => {
    const headers = { "Content-Type": "application/x-www-form-urlencoded" };
    try {
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Fetch local JSON assets (like static JSON files)
  getLocalAssets: async (name) => {
    const headers = { "Content-Type": "application/x-www-form-urlencoded" };
    try {
      const response = await axios.get(`assets/json/${name}`, { headers });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default ApiService;
